// src/utils/mixpanel.ts
import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '7915e0feffed9752c2db40ee554a5f7c';
//`5567c24874e812b86477340a29bb60f2`; //'7915e0feffed9752c2db40ee554a5f7c';
// process.env.REACT_APP_APPLE_REDIRECT_URL;

mixpanel.init(MIXPANEL_TOKEN!, {
  debug: true, // log events in console (useful in dev)
  ignore_dnt: true, // track even if “Do Not Track” is on (optional)
  persistence: 'localStorage',
  record_sessions_percent: 1,
  record_min_ms: 5000,
  record_idle_timeout_ms: 10000,
  record_heatmap_data: true,
});

mixpanel.start_session_recording();

// setTimeout(() => {
//   mixpanel.stop_session_recording();
// }, 50000);

// setTimeout(() => {
//   document.querySelectorAll('button').forEach(btn => {
//     btn.addEventListener('click', () => {
//       mixpanel.track('Button Click', {
//         id: btn.id,
//         text: btn.innerText,
//         page: window.location.pathname,
//       });
//     });
//   });
// }, 5000);

// export const useSessionRecording = () => {
//   useEffect(() => {
//     let recordingStarted = false;

//     const startRecording = () => {
//       if (!recordingStarted) {
//         mixpanel.start_session_recording();
//         recordingStarted = true;
//         console.log('Mixpanel session recording started');
//       }
//     };

//     const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
//     events.forEach(evt => window.addEventListener(evt, startRecording, { once: true }));

//     return () => {
//       events.forEach(evt => window.removeEventListener(evt, startRecording));
//       if (recordingStarted) {
//         mixpanel.stop_session_recording();
//         console.log('Mixpanel session recording stopped');
//       }
//     };
//   }, []);
// };

export default mixpanel;
